import { SET_4DGAME_SUBTYPE,SET_4DGAME_SUB_CHILDTYPE } from "./actionTypes";
const initialState ={
    game_sub_type:"4D3D2D",
    game_sub_child_type:"DISCOUNT",

}


const GameSubType=(state=initialState,action)=>{
    switch(action.type){
        case SET_4DGAME_SUBTYPE:
            let tempState = { ...state };
            tempState[action.payload.key] = action.payload.value;
            state = { ...state, ...tempState };
            break
            case SET_4DGAME_SUB_CHILDTYPE:
                let tempSubState = { ...state };
                tempSubState[action.payload.key] = action.payload.value;
            state = { ...state, ...tempSubState };
            break

    }
    return state
}
export default GameSubType